<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center" class="ma-0">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-skeleton-loader v-if="isLoading" :loading="isLoading" type="card, article, card-actions" />
        <v-scale-transition>
          <v-card v-if="!isLoading" elevation="10">
            <v-card-title class="title">Informações do pagamento</v-card-title>
            <v-card-text v-if="!isLoading">
              <!-- Items/Prices -->
              <v-container fluid class="fill-height">
                <v-row class="ma-0">
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <span class="title">Produto</span>
                    <v-flex class="d-flex flex-column">
                      <span class="subtitle-1 text-truncate">{{ postPaymentData.product.name }}</span>
                      <span class="caption text-truncate">{{ postPaymentData.product.description }}</span>
                      <span v-if="mustShowCdExternalCode" class="caption text-truncate">
                        <b>Código da transação: </b>{{ postPaymentData["transaction"]["cd_external_code"] }}
                      </span>
                    </v-flex>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <span class="title">Preços</span>
                    <v-row justify="space-between" class="ma-0">
                      <span class="body-1"><b>Preço total:</b></span>
                      <span class="body-1">{{ postPaymentData["transaction"]["fl_total_price"] |
                        floatToFixedWithComma }}</span>
                    </v-row>
                    <v-row v-if="hasDiscount" justify="space-between" class="ma-0">
                      <span class="caption"><b>Descontos:</b></span>
                      <span class="caption">{{ postPaymentData["transaction"]["fl_discount"] |
                        floatToFixedWithComma }}</span>
                    </v-row>
                    <v-row v-if="hasCreditsUsed" justify="space-between" class="ma-0">
                      <span class="caption"><b>Créditos usados:</b></span>
                      <span class="caption">{{ (postPaymentData["transaction"]["int_credits_used"] / 100) |
                        floatToFixedWithComma }}</span>
                    </v-row>
                    <v-divider class="my-1" />
                    <v-row justify="space-between" class="ma-0">
                      <span class="body-1"><b>Preço final:</b></span>
                      <span class="body-1">{{ postPaymentData["transaction"]["fl_final_price"] |
                        floatToFixedWithComma }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
              <v-divider />
              <v-container fluid class="fill-height">
                <v-row class="ma-0">
                  <component :is="mainInfoComponent" />
                </v-row>
              </v-container>
              <v-divider />
              <v-container fluid class="fill-height">
                <v-row class="ma-0">
                  <v-col>
                    <v-flex class="d-flex flex-column">
                      <p v-if="!paymentMethodIsNoType" class="subtitle-1">
                        A nota fiscal referente ao pagamento será enviada por e-mail.
                      </p>
                      <p class="subtitle-2">Em caso de dúvida: <b>mappa@horusaeronaves.com</b></p>
                    </v-flex>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-scale-transition>
      </v-col>
    </v-row>
    <v-row align="start" justify="center" class="ma-0">
      <v-btn :loading="isLoading" large color="primary" to="/app/processing-list">
        <v-icon class="mr-2">mdi-layers</v-icon>
        Ir para os meus processamentos
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import { GET_POST_PAYMENT_DATA } from "../../store/modules/post-payment"
import { includes } from "lodash/collection"
import { PAYMENT_METHOD } from "../../helpers/payment/constants"
import { isEqual } from "lodash/lang"
import NoTypeMainInfo from "../../components/PostPayment/NoTypeMainInfo"
import CreditCardMainInfo from "../../components/PostPayment/CreditCardMainInfo"
import PostPayMainInfo from "../../components/PostPayment/PostPayMainInfo"
import BoaCompraMainInfo from "../../components/PostPayment/BoaCompraMainInfo"

export default {
  name: "PostPayment",
  data: () => ({
    isLoading: true,
    mainInfoComponent: null,
  }),
  methods: {
    onMounted() {
      if (!this.postPaymentData) {
        this.$router.push("/app/processing-list")
        return
      }
      switch (this.postPaymentData["paymentMethod"]) {
        case PAYMENT_METHOD.NO_TYPE:
          this.mainInfoComponent = NoTypeMainInfo
          break
        case PAYMENT_METHOD.BOACOMPRA:
          this.mainInfoComponent = BoaCompraMainInfo
          break
        case PAYMENT_METHOD.POST_PAY:
          this.mainInfoComponent = PostPayMainInfo
          break
        case PAYMENT_METHOD.CREDIT_CARD:
        case PAYMENT_METHOD.SAVED_CREDIT_CARD:
          this.mainInfoComponent = CreditCardMainInfo
          break
        default:
          break
      }
      this.isLoading = false
    },
  },
  filters: {
    floatToFixedWithComma(value) {
      return value.toFixed(2)
    },
  },
  computed: {
    paymentMethodIsNoType() {
      if (!this.postPaymentData) return true
      return isEqual(this.postPaymentData["paymentMethod"], PAYMENT_METHOD.NO_TYPE)
    },
    mustShowCdExternalCode() {
      if (!this.postPaymentData) return false
      return !includes([PAYMENT_METHOD.NO_TYPE, PAYMENT_METHOD.BOACOMPRA], this.postPaymentData.paymentMethod)
    },
    hasDiscount() {
      if (!this.postPaymentData) return false
      return !isEqual(this.postPaymentData["transaction"]["fl_discount"], 0)
    },
    hasCreditsUsed() {
      if (!this.postPaymentData) return false
      return !isEqual(this.postPaymentData["transaction"]["int_credits_used"], 0)
    },
    ...mapGetters({
      postPaymentData: GET_POST_PAYMENT_DATA,
    }),
  },
  created() {
    this.$nextTick(() => {
      this.onMounted()
    })
  },
}
</script>

<style scoped></style>
